/* global VXConfig */
import React                     from 'react';
import PropTypes                 from 'prop-types';
import Flux                      from '../../../../../flux/Flux';
import Translations              from '../../../../../utils/Translations';
import AlbumPriceLabel           from '../../../../Dailybonus/SubComponents/AlbumPriceLabel';
import {formatEffectAsPlainText,
	isCurrencyVoucher}            from '../../../../Dailybonus/dailyBonusHelpers';

const {offers} = Flux.Constants.DailyBonuses;


class DailybonusPhotoVideoOfferDescr extends React.Component {

	render() {
		const {offer, effect, content, purchased, free} = this.props;
		const isVoucher = content ? isCurrencyVoucher(content.price) : false;
		const isVideo   = offer === offers.VIDEO;
		return (
			<div className={'dailybonus__mobile--item__description' + (isVoucher ? ' dailybonus__mobile--item__description--voucher' : '')}>
				{
					purchased ? (
						<div className='dailybonus__mobile--item__description__offer-no-effect'>
							{isVideo ? Translations.get('Bonus365MobileVideoTitle') : Translations.get('Bonus365MobilePhotoAlbumTitle')}
						</div>
					) : (isVoucher ?
						<div className='dailybonus__mobile--item__description__offer-no-effect'>
							<div>{(isVideo ? Translations.get('Video') : Translations.get('Gallery'))}</div>
							<div>{content.price.currency}</div>
						</div>

						:
						<div className="dailybonus__mobile--item__description__offer">
							{!free && (
								<div className='dailybonus__mobile--item__description__offer-effect' style={(!Flux.Guest.isLoggedIn() && VXConfig.isVXMobilePlatform) ? {marginTop: "15px"} : {}}>
									<div>-{formatEffectAsPlainText(effect)}</div>
									{content && !free && Flux.Guest.isLoggedIn() &&
										<AlbumPriceLabel
											price={content.price}
											basePrice={content.basePrice}
											discountedPrice={content.dailyBonusPrice}
											additionalClass="--price-big"
											purchased={purchased}
										/>
									}
								</div>
							)}
							{free && (
								<div className='dailybonus__mobile--item__description__offer-no-effect'>
									{Translations.get('Free') + ' ' + (isVideo ? Translations.get('Video') : Translations.get('Gallery'))}
								</div>
							)}
						</div>
					)
				}
			</div>
		);
	}
}

DailybonusPhotoVideoOfferDescr.propTypes = {
	offer:     PropTypes.string.isRequired,
	effect:    PropTypes.object,
	content:   PropTypes.object,
	purchased: PropTypes.bool,
	free:      PropTypes.bool,
};

DailybonusPhotoVideoOfferDescr.defaultProps = {
	purchased: false,
	free:      false,
};

export default DailybonusPhotoVideoOfferDescr;
